// Media
export const VIDEO_CROP_SIZE_SET = 'VIDEO_CROP_SIZE_SET'
export const MEDIA_LAYOUT_SET = 'MEDIA_LAYOUT_SET'
export const MEDIA_BOX_TRANSFORM_SET = 'MEDIA_BOX_TRANSFORM_SET'
export const SET_VIDEO_STREAM_SIZE = 'SET_VIDEO_STREAM_SIZE'
export const SET_ORIGIN_SIZE = 'SET_ORIGIN_SIZE'
export const SET_CLIENT_RECTANGLE_SIZE = 'SET_CLIENT_RECTANGLE_SIZE'
export const SET_SNAP_GRID_POSITION = 'snap-grid-position'
export const CAMERA_DIMENSION = 'set-camera-dimension'
